import React from 'react'
import { Head, router } from '@inertiajs/react'
import AdminLayout from '../../../components/AdminLayout'
import AdminTable from '../../../components/AdminTable'

interface Vertical {
  id: number
  name: string
  offers_count: number
  created_at: string
}

interface Props {
  verticals: Vertical[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    prev_page?: number
    next_page?: number
  }
  filters: {
    search?: string
  }
  can_edit: boolean
}

function VerticalsIndex({ verticals, pagination, filters, can_edit }: Props) {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'offers_count', label: 'Offers' },
    { key: 'created_at', label: 'Created At' },
  ]

  const formFields = [
    { name: 'name', label: 'Name', type: 'text' as const, required: true }
  ]

  const handleCreate = (formData: any) => {
    router.post('/verticals', { vertical: formData })
  }

  const handleEdit = (item: any) => {
    const isConfirmed = window.confirm(`Are you sure you want to update the vertical "${item.name}"?`)
    if (isConfirmed) {
      router.put(`/verticals/${item.id}`, { vertical: { name: item.name } })
    }
  }

  const handleDelete = (item: any) => {
    if (item.offers_count > 0) {
      alert('Cannot delete vertical with associated offers.')
      return
    }
    
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the vertical "${item.name}"?\n\nThis action cannot be undone.`
    )
    if (isConfirmed) {
      router.delete(`/verticals/${item.id}`)
    }
  }

  return (
    <>
      <Head title="Verticals | Mailkit - Resolute" />
      <AdminTable
        title="Verticals"
        description="Manage verticals in the system"
        data={verticals}
        columns={columns}
        pagination={pagination}
        filters={filters}
        can_edit={can_edit}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
        searchPlaceholder="Search verticals..."
        basePath="/verticals"
        formFields={formFields}
      />
    </>
  )
}

VerticalsIndex.layout = page => <AdminLayout>{page}</AdminLayout>

export default VerticalsIndex